"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrchestrator = void 0;
var orchestrator_1 = require("./orchestrator");
var get_orchestrator_1 = require("./get-orchestrator");
Object.defineProperty(exports, "getOrchestrator", { enumerable: true, get: function () { return get_orchestrator_1.getOrchestrator; } });
exports.default = orchestrator_1.Orchestrator;
